(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbs-news-quotes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sbs-news-quote-gallery')) {
  customElements.define('sbs-news-quote-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.slides = Array.from(this.querySelectorAll('[data-quote]'));
      this.index = 0;
      this.status = this.querySelector('[data-status]');
      this.querySelector('[data-controls]').hidden = this.slides.length < 2;
      this.show(0);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (button && this.contains(button)) this.show(this.index + Number(button.dataset.direction));
      }, {signal:this.controller.signal});
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.quote === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, {signal:this.controller.signal});
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.status.textContent = this.status.dataset.pattern.replace('[current]', this.index + 1).replace('[total]', this.slides.length);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
